<div class="d-flex flex-wrap flex-stack mb-6">
  <div class="d-flex flex-wrap my-2 gap-3 align-items-center">
    <h3 class="fw-bold my-0">{{ 'companyProfile.events.title' | translate }}</h3>
    <!-- Filter Dropdown -->
    <div class="dropdown">
      <button class="btn btn-light-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa fa-filter me-2"></i>
        {{ getFilterLabel(selectedFilter) }}
        <span class="badge badge-circle badge-sm badge-primary ms-2">{{ getFilterCount(selectedFilter) }}</span>
      </button>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item" [class.active]="selectedFilter === 'all'" (click)="onFilterChange('all')">
            <i class="fa fa-list me-2"></i>
            {{ 'companyProfile.events.filters.all' | translate }}
            <span class="badge badge-light-primary ms-2">{{ getFilterCount('all') }}</span>
          </a>
        </li>
        <li>
          <a class="dropdown-item" [class.active]="selectedFilter === 'upcoming'" (click)="onFilterChange('upcoming')">
            <i class="fa fa-calendar-check text-success me-2"></i>
            {{ 'companyProfile.events.filters.upcoming' | translate }}
            <span class="badge badge-light-success ms-2">{{ getFilterCount('upcoming') }}</span>
          </a>
        </li>
        <li>
          <a class="dropdown-item" [class.active]="selectedFilter === 'past'" (click)="onFilterChange('past')">
            <i class="fa fa-calendar-minus text-secondary me-2"></i>
            {{ 'companyProfile.events.filters.past' | translate }}
            <span class="badge badge-light-secondary ms-2">{{ getFilterCount('past') }}</span>
          </a>
        </li>
        <li>
          <a class="dropdown-item" [class.active]="selectedFilter === 'co-organised'" (click)="onFilterChange('co-organised')">
            <i class="fa fa-users-gear text-info me-2"></i>
            {{ 'companyProfile.events.filters.coOrganised' | translate }}
            <span class="badge badge-light-info ms-2">{{ getFilterCount('co-organised') }}</span>
          </a>
        </li>
        <li>
          <a class="dropdown-item" [class.active]="selectedFilter === 'cancelled'" (click)="onFilterChange('cancelled')">
            <i class="fa fa-ban text-danger me-2"></i>
            {{ 'companyProfile.events.filters.cancelled' | translate }}
            <span class="badge badge-light-danger ms-2">{{ getFilterCount('cancelled') }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="my-2">
    <app-button
      [variant]="'primary'"
      [label]="'companyProfile.events.createEvent' | translate"
      [iconClass]="'fa fa-magic'"
      (clicked)="openAddEvent()"
    />
  </div>
</div>
<div class="row g-6 g-xl-9 mb-9" [class.opacity-50]="loading || deleting" [class.pointer-events-none]="loading || deleting">
  @for (event of events; track event.event_id) {
    <div class="col-md-6 col-xl-4">
      <app-event-card
        [event]="event"
        [showDelete]="true"
        (deleteRequested)="onDeleteEvent($event)"
      />
    </div>
  }
  @if (!loading && (!events || events.length === 0)) {
    <div class="col-12">
      <div class="card">
        <div class="card-body text-center py-15">
          <i class="fa fa-calendar-alt fs-3x text-muted mb-5"></i>
          <h4 class="text-muted">{{ 'companyProfile.events.noEvents' | translate }}</h4>
          <p class="text-muted mb-5">{{ 'companyProfile.events.noEventsHint' | translate }}</p>
          <app-button
            [label]="'companyProfile.events.createEvent' | translate"
            [variant]="'primary'"
            [iconClass]="'fa fa-magic'"
            (clicked)="openAddEvent()"
          />
        </div>
      </div>
    </div>
  }
</div>

<!-- Co-Organised Events Section -->
@if ((selectedFilter === 'all' || selectedFilter === 'co-organised') && coOrganisedEvents && coOrganisedEvents.length > 0) {
  <div class="d-flex flex-wrap flex-stack mb-6 mt-10">
    <h3 class="fw-bold my-2">
      <i class="fa fa-users-gear me-2 text-muted"></i>
      {{ 'companyProfile.events.coOrganised' | translate }}
    </h3>
  </div>
  <div class="row g-6 g-xl-9 mb-9" [class.opacity-50]="loadingCoOrganised">
    @for (coOrgEvent of coOrganisedEvents; track coOrgEvent.event.event_id) {
      <div class="col-md-6 col-xl-4">
        <div class="position-relative">
          <app-event-card
            [event]="coOrgEvent.event"
            [showDelete]="false"
          />
          <span
            class="badge position-absolute"
            [class]="getAccessLevelBadgeClass(coOrgEvent.access_level)"
            style="top: 10px; right: 25px; z-index: 5;"
          >
            {{ 'companyProfile.events.accessBadge.' + coOrgEvent.access_level | translate }}
          </span>
        </div>
      </div>
    }
  </div>
}

<!-- Cancelled Events Section -->
@if (showCancelledSection) {
  <div class="d-flex flex-wrap flex-stack mb-6 mt-10">
    <h3 class="fw-bold my-2">
      <i class="fa fa-ban me-2 text-danger"></i>
      {{ 'companyProfile.events.cancelledEvents' | translate }}
    </h3>
  </div>
  <div class="row g-6 g-xl-9 mb-9">
    @for (event of cancelledEvents; track event.event_id) {
      <div class="col-md-6 col-xl-4">
        <app-event-card
          [event]="event"
          [showDelete]="true"
          (deleteRequested)="onDeleteEvent($event)"
        />
      </div>
    }
  </div>
}
